module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _vm._l((_vm.films), function(film) {
    return _c('div', {
      key: film.id,
      staticClass: "film"
    }, [_c('a', {
      attrs: {
        "href": _vm.filmUrl(film.id),
        "target": "_blank"
      }
    }, [(_vm.tmdb.config) ? _c('img', {
      attrs: {
        "src": _vm.imageUrl(film.backdrop_path)
      }
    }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v("\n    " + _vm._s(film.original_title) + "\n  ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc34fe84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LastTenFilms.vue
// module id = 78
// module chunks = 0